import type {
  ConversationArchiveState,
  ConversationCapabilities,
  DurableConversation,
} from "@/api/conversations";
import { getDesktopChatAuthScope } from "@/desktop/desktop-chat-auth-scope";
import type { ConversationMessage } from "@/stores/conversation-store";

interface ListCacheEntry {
  scopeKey: string;
  rows: DurableConversation[];
  nextCursor: string | null;
  hasMore: boolean;
  capabilities: ConversationCapabilities;
}

interface HistoryCacheEntry {
  rows: ConversationMessage[];
  nextCursor: string | null;
  hasMore: boolean;
  ordering: string;
}

export const listCache = new Map<string, ListCacheEntry>();
export const historyCache = new Map<string, HistoryCacheEntry>();

export function conversationBrowserAccountKey(): string | null {
  const scope = getDesktopChatAuthScope();
  return scope ? `${scope.accountId}:${scope.epoch}` : null;
}

export function clearConversationBrowserCache(): void {
  listCache.clear();
  historyCache.clear();
}

export function listCacheKey(
  scopeKey: string,
  archiveState: ConversationArchiveState,
  query: string,
  limit: number,
  projectId: string | null = null,
): string {
  return JSON.stringify([scopeKey, archiveState, query, limit, projectId]);
}

export function invalidateListCache(scopeKey: string): void {
  for (const [key, entry] of listCache) {
    if (entry.scopeKey === scopeKey) listCache.delete(key);
  }
}

export function uniqueById<T extends { id: string }>(rows: T[]): T[] {
  const seen = new Set<string>();
  return rows.filter((row) => {
    if (seen.has(row.id)) return false;
    seen.add(row.id);
    return true;
  });
}
